import React from 'react';
import { Link } from 'react-router-dom';
import './Calibration.css';
import BoxesImage from './Assets/scale.jpg';

const Calibration = () => {
  return (
    <div className="calibration-container">
      <div className="banner-container-calibration">
        <img src={BoxesImage} alt="Boxes" className="banner-image-calibration" />
        <div className="banner-text">Calibration</div>
      </div>
      <hr className="separator" />

      <div className="section">
        <h2>Database Looks</h2>
        <div className="quick-views-container">
          <Link to="/calibration-devices" className="link-button">
            <button className="calibration-button">Calibration Devices</button>
          </Link>
          <Link to="/calibration-devices" className="link-button">
            <button className="calibration-button">Calibration Report</button>
          </Link>
          <Link to="/calibration-devices" className="link-button">
            <button className="calibration-button">Calibration Management</button>
          </Link>
        </div>
      </div>

      <div className="section">
        <h2>Quick Actions</h2>
        <div className="actions-container">
          <Link to="/" className="link-button">
            <button className="calibration-button action-button">Create Calibration Item</button>
          </Link>
          <Link to="/" className="link-button">
            <button className="calibration-button action-button">Add Calibration Entry</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Calibration;